import React, { useState } from 'react';
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import VerticalTable from '../../components/verticalTable';
import BarChart from '../../components/chartTypes/Barchart';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';


const CoLendingSummary = () => {
  const { t } = useTranslation();
  

  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>({
    periodWithOutDay: ["month"],
    fromDate: [sixMonthsAgoFormatted],
    toDate: [twoDaysAgoFormatted],
  });

  const filters = [
    { key: "state", type: "select", label: t("filters.state") },
    // { key: "territory", type: "select", label: t("filters.territory") },
    { key: "cluster", type: "select", label: t("filters.cluster") },
    { key: "branch", type: "select", label: t("filters.branch") },
    { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
    { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
    { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
  ];

  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  
    const handleFilterChange = (updatedValues: Record<string, string[]>) => {
      setSelectedFilters(updatedValues);
    };
  
    const handleCancelClick = () => {
      setSelectedFilters({
        periodWithOutDay: ["month"],
        fromDate: [sixMonthsAgoFormatted],
        toDate: [twoDaysAgoFormatted]
      });
      setApplyFilter(!applyFilter);
    };
  // Columns shared across tables
  const months = ["Feb 24", "Mar 24", "Apr 24", "May 24", "Jun 24", "Jul 24", "Aug 24", "Sep 24", "Oct 24", "Nov 24", "Dec 24"];

  // === Section: New Origination Co-lending Loans (100:0) ===
  const originationHeaders = ["", ...months,"Total"];
  const originationData = [
    { category: "New Origination", values: ["2.54M", "2.42M", "2.30M", "2.10M", "2.05M", "1.97M", "2.02M", "1.94M", "1.86M", "1.80M", "1.75M"] },
    { category: "Amount Disb", values: ["2.30M", "2.28M", "2.15M", "2.00M", "1.98M", "1.90M", "1.88M", "1.80M", "1.75M", "1.70M", "1.69M"] },
  ];

  // === Portfolio Table ===
  const portfolioHeaders = ["Items", ...months];
  const portfolioData = [
    { category: "Total Demand ADD", values: ["0.84M", "1.26M", "1.78M", "1.23M", "1.04M", "0.97M", "1.30M", "0.90M", "0.85M", "1.02M", "0.96M"] },
    { category: "Total Received ADD", values: ["0.82M", "1.23M", "1.76M", "1.21M", "1.01M", "0.93M", "1.25M", "0.88M", "0.84M", "1.00M", "0.94M"] },
  ];

  // === Delinquency Table ===
  const delinquencyHeaders = ["DPD Buckets", ...months];
  const delinquencyData = [
    { category: "0L Current", values: ["97.1%", "97.4%", "97.7%", "97.2%", "97.2%", "97.3%", "96.9%", "97.0%", "97.4%", "97.6%", "97.5%"] },
    { category: "01-29 DPD", values: ["1.5%", "1.3%", "1.1%", "1.3%", "1.4%", "1.2%", "1.5%", "1.3%", "1.1%", "1.0%", "1.2%"] },
    { category: "30-59 DPD", values: ["0.9%", "0.7%", "0.5%", "0.8%", "0.7%", "0.6%", "0.9%", "0.8%", "0.6%", "0.7%", "0.5%"] },
    { category: "60-89 DPD", values: ["0.3%", "0.3%", "0.3%", "0.3%", "0.3%", "0.3%", "0.3%", "0.3%", "0.3%", "0.3%", "0.3%"] },
    { category: "90+ DPD", values: ["0.2%", "0.3%", "0.4%", "0.4%", "0.4%", "0.6%", "0.4%", "0.6%", "0.6%", "0.4%", "0.5%"] },
  ];

  // === Bar Chart Data ===
  const barChartLabels = ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Chennai", "Kolkata", "Ahmedabad", "Pune", "Jaipur", "Lucknow"];
  const barChartData = [
    {
      label: t('Co-lending.Branch.label1'),
      data: [2.5, 2.3, 2.1, 1.9, 1.8, 1.6, 1.5, 1.4, 1.2, 1.1],
      backgroundColor: "#6a994e",
    },
    {
      label: t('Co-lending.Branch.label2'),
      data: [2.3, 2.1, 2.0, 1.8, 1.7, 1.4, 1.3, 1.3, 1.1, 1.0],
      backgroundColor: "#bc4749",
    },
  ];

  return (
    <div className="page-content">
      <div className="header">{t('Co-lending.pageTitle')}</div>

      <div className="content px-3">
        <MultiSelectCheckboxGroup
          filters={filters}
          selectedValues={selectedFilters}
          onChange={handleFilterChange}
          isLoading={[false]}
          buttons={[
            { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
            { label: t("buttons.cancel"), onClick: handleCancelClick },
            { label: t("buttons.download"), onClick: () => alert("Download triggered") },
          ]}
        />
      </div>
        <div className="p-2 me-3 ">
                 <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('Co-lending.Loans')}</h2>
        <VerticalTable headers={originationHeaders} data={originationData} loading={false} />
      </div>

      
        <div className="p-2 me-3 mt-5">
                 <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('Co-lending.Portfolio')}</h2>
        <VerticalTable headers={portfolioHeaders} data={portfolioData} loading={false} />
      </div>

      
        <div className="p-2 me-3 mt-5">
                 <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('Co-lending.Delinquency')}</h2>
        <VerticalTable headers={delinquencyHeaders} data={delinquencyData} loading={false} />
      </div>

      
        <div className="p-2 me-3 mt-5">
                 <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('Co-lending.Branch.pageTitle')}</h2>
        <BarChart
          title=""
          labels={barChartLabels}
          dataSets={barChartData}
          xLabel={t('Co-lending.Branch.Branches')}
          yLabel={t('Co-lending.Branch.Amount')}
        />
      </div>
    </div>
  );
};

export default CoLendingSummary;
